import React from 'react';
import validationRules from "../../validations/contactusvalidationrules.json";
import "../../styles/textinput.css";

const EmailInput = ({ name, value, onChange, error, setError }) => {
  const handleBlur = (e) => {
    const emailRules = validationRules.email;
    let errorMessage = '';
    
    if (!e.target.value) {
      errorMessage = "Email is required";
    } else {
      const emailPattern = new RegExp(emailRules.pattern);
      if (!emailPattern.test(e.target.value)) {
        errorMessage = emailRules.errorMessage;
      } else {
        const domain = e.target.value.split('@')[1]?.toLowerCase();
        if (emailRules.restrictedDomains.includes(domain)) {
          errorMessage = emailRules.errorMessage;
        }
      }
    }
    setError(errorMessage);
  };

  return (
    <div className="form-group">
      <input
        type="email"
        name={name}
        placeholder="Email"
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
      />
      {error && <span className="error">{error}</span>}
    </div>
  );
};

export default EmailInput; 